import React, { Component } from 'react';
import { GraingerAccountContext } from '../../Context/Context';

import './Contact.scss'
import Page from '../../Components/Page/Page'
import { Row, Column } from '../../Components/Grid/Grid'

import Front from '../../Assets/building-front.jpg'

class Contact extends Component {
  constructor(props) {
    super(props);

    this.state = {
    }
  }

  getContactInfo(name, values) {
    return (
      <div className='contact-info'>
        <span className='contact-subheader'>{name}:</span>
        {values.map((value) => {
          return (<p>{value}</p>);
        })}
      </div>
    );
  }

  render() {
    return (
      <Page title='Contact Us'>
        <Row className='contact-container'>
          <Column className='contact-info-column'>
            {this.getContactInfo('Office', ['Level 1', '8 - 10 Purdue St', 'Belconnen ACT 2617'])}
            {this.getContactInfo('Phone',  ['02 62533511'])}
            {this.getContactInfo('Postal', ['PO Box 5 Belconnen ACT 2616'])}
            {this.getContactInfo('Email',  ['admin@graingercpa.com.au'])}
          </Column>
          <Column>
            <span className='contact-subheader'>Location:</span>
            <iframe
              className='contact-map'
              title='Map'
              src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d814.649630969341!2d149.0580788292059!3d-35.24136290345006!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b17ad78847f4227%3A0xf757ba576a30ffc5!2sGrainger+Platt!5e0!3m2!1sen!2sau!4v1544104478017'
            />
          </Column>
          <div className='contact-entrance-container'>
            <span className='contact-subheader'>Entrance:</span>
            <img className='contact-entrance-img no-select' src={Front} alt='Building Front' />
          </div>
        </Row>
      </Page>
    );
  }
}

Contact.contextType = GraingerAccountContext;
export default Contact;